import { render, staticRenderFns } from "./musclePatch.vue?vue&type=template&id=8f4b134e&"
import script from "./musclePatch.vue?vue&type=script&lang=js&"
export * from "./musclePatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f4b134e')) {
      api.createRecord('8f4b134e', component.options)
    } else {
      api.reload('8f4b134e', component.options)
    }
    module.hot.accept("./musclePatch.vue?vue&type=template&id=8f4b134e&", function () {
      api.rerender('8f4b134e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/musclePatch.vue"
export default component.exports